(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pincode-checker"] && !Shopify.designMode) return;
  try {
    (function () {
  var mumbaiCodes = [
    400001, 400002, 400003, 400004, 400005, 400006, 400007, 400008, 400009, 400010,
    400011, 400012, 400013, 400014, 400015, 400016, 400017, 400018, 400019, 400020,
    400021, 400022, 400023, 400024, 400025, 400026, 400027, 400028, 400029, 400030,
    400031, 400032, 400033, 400034, 400035, 400036, 400037, 400038, 400039, 400041,
    400042, 400043, 400049, 400050, 400051, 400052, 400054, 400055, 400056, 400057,
    400058, 400059, 400060, 400061, 400062, 400063, 400064, 400065, 400066, 400067,
    400068, 400069, 400070, 400071, 400072, 400073, 400074, 400075, 400076, 400077,
    400078, 400079, 400080, 400081, 400082, 400083, 400084, 400085, 400086, 400087,
    400088, 400089, 400090, 400091, 400092, 400093, 400094, 400095, 400096, 400097,
    400098, 400099, 400101, 400102, 400103, 400104
  ];

  var naviMumbaiCodes = [400611, 400614, 400701, 400703];
  var thaneCodes = [400601, 400602, 400603, 400604, 400605, 400606, 400607, 400608];

  var pincodeVerified = false;

  // Buttons inside the add-on section should never be gated by the pincode check
  var EXCLUDE_SELECTOR = '.product-addons-section';

  function isServiceable(pin) {
    pin = parseInt(pin, 10);
    if (isNaN(pin)) return false;

    if (mumbaiCodes.indexOf(pin) !== -1) return true;
    if (naviMumbaiCodes.indexOf(pin) !== -1) return true;
    if (thaneCodes.indexOf(pin) !== -1) return true;

    return false;
  }

  function isAddonButton(btn) {
    return !!btn.closest(EXCLUDE_SELECTOR);
  }

  function getAddToCartButtons() {
    var all = document.querySelectorAll('button[name="add"]');
    var filtered = [];
    all.forEach(function (btn) {
      if (!isAddonButton(btn)) filtered.push(btn);
    });
    return filtered;
  }

  function updateButtonVisual() {
    getAddToCartButtons().forEach(function (btn) {
      if (pincodeVerified) {
        btn.classList.remove('pincode-locked');
      } else {
        btn.classList.add('pincode-locked');
      }
    });
  }

  updateButtonVisual();

  function checkPincode(pin, wrapper) {
    var msg = wrapper.querySelector('[data-pincode-message]');

    if (!/^\d{6}$/.test(pin)) {
      msg.className = 'pincode-checker__message error';
      msg.textContent = 'Please add your pincode to check delivery.';
      pincodeVerified = false;
      updateButtonVisual();
      return;
    }

    if (isServiceable(pin)) {
      msg.className = 'pincode-checker__message success';
      msg.textContent = 'Delivery available at your pincode.';
      pincodeVerified = true;
    } else {
      msg.className = 'pincode-checker__message error';
      msg.innerHTML = 'We apologize that currenty we do not ship to your Location.';
      pincodeVerified = false;
    }
    updateButtonVisual();
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('button[name="add"]');
    if (!addBtn) return;

    // Skip pincode gating entirely for add-on section buttons
    if (isAddonButton(addBtn)) return;

    if (!pincodeVerified) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      var msg = document.querySelector('.pincode-wrapper [data-pincode-message]');
      if (msg) {
        msg.className = 'pincode-checker__message error';
        msg.textContent = 'Please check delivery availability for your pincode first.';
      }
      var input = document.querySelector('.pincode-wrapper [data-pincode-input]');
      if (input) input.focus();
    }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pincode-check-btn]');
    if (!btn) return;
    var wrapper = btn.closest('.pincode-wrapper');
    if (!wrapper) return;
    var input = wrapper.querySelector('[data-pincode-input]');
    checkPincode(input.value.trim(), wrapper);
  });

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-pincode-input]');
    if (!input) return;
    var wrapper = input.closest('.pincode-wrapper');
    if (!wrapper) return;
    var msg = wrapper.querySelector('[data-pincode-message]');
    var pin = input.value.trim();

    if (pin.length === 0) {
      msg.className = 'pincode-checker__message error';
      msg.textContent = 'Please add pincode to check delivery.';
      pincodeVerified = false;
      updateButtonVisual();
      return;
    }

    if (pin.length === 6) {
      checkPincode(pin, wrapper);
    } else {
      pincodeVerified = false;
      updateButtonVisual();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
